"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconTeamDriver = function SvgIconTeamDriver(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "team driver icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Team Driver Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.986 27.334c3.95 0 7.555.988 9.885 1.818a4.66 4.66 0 013.1 4.376v6.791a.927.927 0 01-.927.928H5.928A.927.927 0 015 40.319v-6.791a4.66 4.66 0 013.1-4.376c2.33-.83 5.936-1.818 9.886-1.818zm15.811 1.833c3.409 0 6.049.623 7.664 1.147A3.683 3.683 0 0144 33.834v4.609a.927.927 0 01-.928.927h-8.434v-5.842a8.28 8.28 0 00-1.24-4.358c.132-.002.265-.003.399-.003zm0-19.478c4.091 0 7.42 3.329 7.42 7.42 0 4.2-3.31 9.275-7.42 9.275-2.506 0-4.713-1.885-6.056-4.308 1.422-2.314 2.26-5.039 2.26-7.728 0-1.148-.162-2.26-.464-3.312a7.38 7.38 0 014.26-1.347zM17.986 6c4.603 0 8.348 3.745 8.348 8.348 0 4.621-3.725 10.203-8.348 10.203-4.624 0-8.348-5.582-8.348-10.203C9.638 9.745 13.382 6 17.986 6z"
  }));
};

var _default = SvgIconTeamDriver;
exports.default = _default;